module.exports = __webpack_public_path__ + "media/images/metronic/social/aboutme-71a41bdc56ab112c13d0c1c6f0349cad.png";